import Separator from "@/components/Separator/Separator";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";

const FooterCareer = ({ config, items }) => {
  return (
    <footer
      className={` bg-blue-dark text-white  lg:min-h-[80px] min-h-[40px]`}
      style={{ contentVisibility: "auto" }}
    >
      <Separator className="!bg-white mb-6" />
      <div className="flex flex-col xl:flex-row lg:justify-between container">
        <p className="text-center mb-6 items-center flex justify-center">
          {config?.footer?.meta?.address}
        </p>
        <Separator className="!bg-white mb-6 lg:hidden" />
        <NavigationMenu.Root
          className={`flex justify-center p-4 w-full mb-6 lg:w-auto flex-col lg:flex-row`}
        >
          <NavigationMenu.List className="flex lg:justify-between justify-start w-full lg:flex-nowrap flex-wrap">
            {items.map(({ title, link, target }) => (
              <NavigationMenu.Item
                key={link}
                className="lg:ml-10 w-1/2 l:w-full"
              >
                <a
                  href={link}
                  target={title === "Karriere" ? "_blank" : target}
                  className="pb-3 border-b-[1px] border-transparent hover:border-white"
                >
                  {title}
                </a>
              </NavigationMenu.Item>
            ))}
            <NavigationMenu.Item className="lg:ml-10">
              <a
                href="#"
                onClick={() => (window as any).UC_SET_VIEW(3)}
                className="pb-3 border-b-[1px] border-transparent hover:border-white"
              >
                Dateneinstellungen
              </a>
            </NavigationMenu.Item>
          </NavigationMenu.List>
        </NavigationMenu.Root>
      </div>
    </footer>
  );
};

export default FooterCareer;
